import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React from 'react';

import logo from '@/assets/img/logo.png';
import { ViewWrapper } from '@/components/viewWrapper/ViewWrapper.comp.tsx';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';

interface Props {
  buttonLabel?: string;
  hideButton?: boolean;
  message?: string;
  onButtonClick?: () => void;
  subMessage?: string;
}

export const GeneralError: React.FC<Props> = props => {
  const { buttonLabel, hideButton, message, onButtonClick, subMessage } = props;
  const { t } = useTranslationWithPrefix('generalError.general');

  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <ViewWrapper>
      <Stack sx={{ alignItems: 'center', height: '100dvh', justifyContent: 'center' }}>
        <img alt="logo" src={logo} style={{ height: '64px' }} />
        <Divider />
        <Stack spacing={4} sx={{ alignItems: 'center', justifyContent: 'center', py: 4 }}>
          <Typography variant="f16Regular">{message ?? t('message')}</Typography>
          <Typography variant="f16Regular">{subMessage ?? t('subMessage')}</Typography>
          {hideButton !== true && (
            <Button onClick={onButtonClick ?? handleGoBack} variant="outlined">
              {buttonLabel ?? t('goBack')}
            </Button>
          )}
        </Stack>
      </Stack>
    </ViewWrapper>
  );
};
